import React, {Component} from 'react';
import * as func from "../../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../../wpconfig"

// const SHOW = 0;
// const SHOW_EDIT = 1;
// const SAVE_EDIT = 2;

class CCodeItem extends Component {
	constructor(props) {
		super(props);

		const r = JSON.parse(JSON.stringify(this.props.record));

		this.state = {
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			parentId: this.props.selectChildCodeId,
			record: r
		}
	}

	keyUp = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record);
	}

	checked = () => {
		const record = this.props.record;

		if (event.target.checked) {
			record[event.target.name] = 'N';
		} else {
			record[event.target.name] = 'Y';
		}
		this.props.onUpdate(this.props.arrIndex, record);
	}

	onEditSave = (e) => {
		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}
		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (!this.props.record.is_edit) {
				func.updateData("code/update", this.props.record).then((response) => {
					// console.log(response)
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.props.onUpdate(this.props.arrIndex, this.props.record, true);
						this.setState({
							record : JSON.parse(JSON.stringify(this.props.record))
						})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				let record = JSON.parse(JSON.stringify(this.props.record));
				if (this.code_id.value === '') {
					this.code_id.focus();
				} else if (record.code_name === '') {
					this.code_name.focus();
				} else {
					record.code_id = this.code_id.value;
					delete record.is_edit;
					func.updateData("code/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.setState({'isEdit': isEdit});
							this.props.onUpdate(this.props.arrIndex, record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							record.code_id = '';
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onCloseDelete = (e) => {
		const record = this.props.record;
		if (record.code_id) {
			if (this.state.isEdit) {
				this.setState({'isEdit': EDIT_MODE.SHOW});
				this.props.onUpdate(this.props.arrIndex, this.state.record);
			} else {
				if (confirm(MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData("code/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.setState({'isEdit': EDIT_MODE.SHOW});
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	};

	onEdit = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
	};

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record.code_id) {
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	};

	onChildrenCode = (e) => {
		this.props.onChildrenCode(this.props.record.code_id);
	}

	render() {
		const record = this.props.record;
		// console.log(record)

		// onChange={this.keyUp}
		return (
			<>
				{this.state.isEdit === EDIT_MODE.SHOW ?
					<tr>
						{/*<td>{this.props.index + 1}</td>*/}
						<td>{record.code_id}</td>
						<td>{record.code_name}</td>
						<td>{record.code_name_eng || ''}</td>
						<td>{record.disp_yn}</td>
						<td>{record.visible_seq}</td>
						<td>
							<div className="btn-group ml-0">
								<button type="button" className="btn btn-outline-success btn-sm" onClick={this.onEditSave}>
									수정
								</button>
								<button type="button" className="btn btn-outline-danger btn-sm" onClick={this.onCloseDelete}>
									삭제
								</button>
							</div>
						</td>
					</tr>
					:
					<tr>
						<td colSpan="7" className="edit-row">
							<div className="">
								<h6>코드목록 추가</h6>
								<div className="row mb-2">
									<div className="col-md-4 form-group">
										<label htmlFor="up_code_id"><strong>상위 코드 ID</strong></label>
										<label className="d-block">{record.up_code_id}</label>
									</div>
									<div className="col-md-4 form-group">
										<label htmlFor="code_id"><strong>코드 ID</strong></label>
										{record.code_id ?
											<label className="d-block">{record.code_id}</label>
											:
											<input type="text" name="code_id" ref={(ref) => this.code_id = ref} defaultValue={record.code_id} className="form-control"/>
										}
									</div>
									<div className="col-md-4 form-group">
										<label htmlFor="code_name"><strong>코드 이름</strong></label>
										<input type="text" name="code_name" ref={(ref)=>this.code_name=ref} value={record.code_name} onChange={this.keyUp} className="form-control" />
									</div>
								</div>
								<div className="row mb-2">
									<div className="col-md-4 form-group">
										<label htmlFor="code_name_eng"><strong>목록 이름(영문)</strong></label>
										<input type="text" name="code_name_eng" value={record.code_name_eng || ''} onChange={this.keyUp} className="form-control" />
									</div>
									<div className="col-md-8 form-group">
										<label htmlFor="code_desc"><strong>목록 설명</strong></label>
										<input type="text" name="code_desc" value={record.code_desc || ''} onChange={this.keyUp} className="form-control" />
									</div>
								</div>
								<div className="row mb-2">
									<div className="col-md-3 form-group">
										<label htmlFor="visible_seq"><strong>순서</strong></label>
										<input type="text" name="visible_seq" value={record.visible_seq} onChange={this.keyUp} className="form-control" />
									</div>
									<div className="col-md-3 form-group">
										<label htmlFor="depth_level"><strong>레벨</strong></label>
										<input type="text" name="depth_level" value={record.depth_level} onChange={this.keyUp} className="form-control" />
									</div>
									{/* <div className="col-md-3 form-group">
										<label htmlFor=""><strong>출력여부</strong></label>
										<div className="mt-1">
											<div className="form-check form-check-inline">
												<input className="form-check-input" type="checkbox" name="disp_yn" id="c_disp_yn" checked={record.disp_yn !== 'Y'} onChange={this.checked} />
												<label className="form-check-label" htmlFor="c_disp_yn">출력안함</label>
											</div>
										</div>
									</div> */}
									{/*<div className="col-md-3 form-group">*/}
									{/*	<label htmlFor=""><strong>삭제-팀장님</strong></label>*/}
									{/*	<div className="mt-1">*/}
									{/*		<div className="form-check form-check-inline">*/}
									{/*			/!*<input className="form-check-input" type="checkbox" name="del_yn" id="del_yn" value="Y"/>*!/*/}
									{/*			<label className="form-check-label" htmlFor="del_yn">삭제</label>*/}
									{/*		</div>*/}
									{/*	</div>*/}
									{/*</div>*/}
								</div>
								{(record.map_code || (this.state.parentId === 'language' || this.state.parentId === 'country')) &&
									<div className="row mb-2">
										<div className="col-md-12 form-group">
											<label htmlFor="map_code"><strong>Map Code</strong></label>
											<input type="text" name="map_code" value={record.map_code || ''} onChange={this.keyUp}
											       className="form-control"/>
										</div>
									</div>
								}
								<div className="btn-group float-right">
									<button type="button" className="btn btn-outline-primary btn-sm" onClick={this.onEditSave}>저장</button>
									<button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.onCloseDelete}>취소</button>
								</div>
							</div>
						</td>
					</tr>
				}
			</>
		)
	}
}

export default CCodeItem;